import BaseService from './BaseService'
export class InfoService extends BaseService {
  // eslint-disable-next-line no-useless-constructor
  constructor (axios) {
    super(axios)
  }
  loadNews (news) {
    const url = '/hy-sb-system/news/newsList'
    return this.httpTool.post(url, news)
      .then((response) => {
        const { content: newList } = response
        var tmpNews = []
        newList.forEach(temNew => {
          var tmpNew = { img: temNew.img, title: temNew.title, description: temNew.description, url: temNew.url }
          tmpNews.push(tmpNew)
        })
        return tmpNews
      })
      .catch(function (error) {
        console.log(error)
        return null
      })
  }
  // 促销信息
  loadPromotionInfos (data) {
    const url = 'hy-sb-item/businessPromotionItem/findBusinessPromotionByPage'
    return this.httpTool.post(url, data)
      .then(response => {
        const { index, size, count, pages, list = [] } = response
        const pageInfo = { index: index, size: size, count: count, pages: pages }
        var infos = []
        infos = this.dealInfos(list)
        console.log(response, '促销信息')
        return { pageInfo: pageInfo, infoList: infos }
      })
      .catch(error => {
        console.log(error)
        return null
      })
  }
  dealInfos (infos) {
    var infoList = []
    infos.forEach(info => {
      var infoNow = {};
      ({ releaseTime: infoNow.editTime, startTime: infoNow.sTime,
        endTime: infoNow.eTime, description: infoNow.desc, name: infoNow.shopName, phone: infoNow.phone } = info)
      infoNow.editTime = infoNow.editTime.substring(0, 10) || ''
      infoNow.sTime = infoNow.sTime.substring(0, 10) || ''
      infoNow.eTime = infoNow.eTime.substring(0, 10) || ''
      const result = `发布时间：${infoNow.editTime}，供应商：${infoNow.shopName}，
        活动时间：${infoNow.sTime}至${infoNow.eTime}，活动内容：${infoNow.desc}
        。联系方式：${infoNow.phone}`
      infoList.push(result)
    })
    return infoList
  }
}
